export const PXAccordion = (function() {
	'use strict';

	let $head, $copy, $id, $group, $copyEls, debounce;
	const HEADER_PADDING = 42
	function init() {
		$group = $('.accordion-group');
		$head = $('.accordion-head');
		$copy = $('.accordion-copy');
		$copyEls = $('[data-accordion-column]');
		events();
		initCopyBoxSizer();
	}

	function events() {
		$group.click(function(){
			$(this).toggleClass('accordion-active');
			$(this).siblings().removeClass('accordion-active');
		});
	}

	function updateAccordionDimensions() {
		$copyEls.each(function() {
			const $this = $(this)
			const $copy = $this.find('.accordion-copy.wysiwyg')
			const $groups = $this.find('.accordion-head')
			const $children = $copy.find(' > p')
			let maxHeight = 0
			$copy.each(function(){
				$(this).parent().addClass('accordion-active');
				maxHeight = Math.max(maxHeight, $(this).outerHeight());				
				$(this).parent().removeClass('accordion-active');
			})
			let outerHeight = maxHeight
			$groups.each(function(){
				outerHeight += $(this).outerHeight() + HEADER_PADDING
			})
			$copy.css({ height : maxHeight })
			//$children.css({ height: maxHeight })
			//console.log($groups.length, outerHeight)
			$this.css({ minHeight: outerHeight })
		})
	}

	function debounceUpdate() {
		clearTimeout(debounce)
		debounce = setTimeout(updateAccordionDimensions,100)
	}

	function initCopyBoxSizer() {
		$(window).on('resize', debounceUpdate)
		debounceUpdate()
	}

	return {
		init: init
	};
})();
